import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';  

@Pipe({
  name: 'tranf'
})
export class TranfPipe implements PipeTransform {

  transform(value: any,list:[],fieldA:string,fieldB:string): any {
   
    if(!list || list.length<1 || !fieldA || !fieldB)
      return value;
    var item = _.find(list,e => e[fieldA]==value);
    
    return item ? item[fieldB] : value;
    
  }

}
